import type { ThemeUIStyleObject } from 'theme-ui';

export const clickable: ThemeUIStyleObject = {
    cursor: 'pointer',
    '&[disabled]': {
        pointerEvents: 'none'
    }
};
